export default __webpack_public_path__ + "static/media/807_bp.c5af5031.svg";